import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const DataBox = Loadable({
    loader: () => import(/* webpackChunkName: "DataBox" */ './dataBox'),
    loading: () => <div />,
});
